"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildSurveyFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BuildSurveyFactory = /** @class */ (function (_super) {
    __extends(BuildSurveyFactory, _super);
    function BuildSurveyFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BuildSurveyFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BuildSurveyFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BuildSurveyFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BuildSurveyFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BuildSurveyFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BuildSurveyFactory;
}(contracts_1.ContractFactory));
exports.BuildSurveyFactory = BuildSurveyFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'hash',
                type: 'bytes32',
            },
        ],
        name: 'Auth1',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'hash',
                type: 'bytes32',
            },
        ],
        name: 'NewSurvey',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'hash',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'uint16[]',
                name: 'answers',
                type: 'uint16[]',
            },
        ],
        name: 'SentSurvey',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        name: 'Funds',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'Incentives',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'accessUser',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: '_title',
                type: 'string',
            },
            {
                internalType: 'string',
                name: '_surveyTitle',
                type: 'string',
            },
            {
                internalType: 'uint256',
                name: '_time',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_ispublic',
                type: 'bool',
            },
        ],
        name: 'addSurvey',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_survey',
                type: 'bytes32',
            },
            {
                internalType: 'address[]',
                name: 'users',
                type: 'address[]',
            },
        ],
        name: 'addUsers',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'announceIncentive',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_survey',
                type: 'bytes32',
            },
        ],
        name: 'collectFunds',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_survey',
                type: 'bytes32',
            },
            {
                internalType: 'uint16[]',
                name: '_feedback',
                type: 'uint16[]',
            },
        ],
        name: 'sendSurvey',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        name: 'surveys',
        outputs: [
            {
                internalType: 'string',
                name: 'title',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'surveyTitle',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'author',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'time',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: 'isPublic',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=BuildSurveyFactory.js.map